import {myJsonFetcher} from "../utils/getData.js"

export function getFetcher(path) {
  return myJsonFetcher(path)
}